import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';
import { AppSettingsRoutingModule } from './app-settings-routing.module';
import { AppSettingsComponent } from './app-settings/app-settings.component';
import { TicketsSettingsComponent } from './app-settings/components/tickets-settings/tickets-settings.component';
import { GeneralSettingsComponent } from './app-settings/components/general-settings/general-settings.component';
import { DataSyncSettingsComponent } from './app-settings/components/data-sync-settings/data-sync-settings.component';
import { TicketsSyncComponent } from './app-settings/components/data-sync-settings/components/tickets-sync/tickets-sync.component';
import {
  ShowDuplicateTicketsTypesPipe,
  ShowMissingTicketsTypesPipe
} from './app-settings/components/data-sync-settings/components/tickets-sync/tickets-sync.pipe';

@NgModule({
  declarations: [
    AppSettingsComponent,
    TicketsSettingsComponent,
    GeneralSettingsComponent,
    DataSyncSettingsComponent,
    TicketsSyncComponent,
    ShowDuplicateTicketsTypesPipe,
    ShowMissingTicketsTypesPipe,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, AppUiModule, SharedModule, AppSettingsRoutingModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppSettingsModule {}
